var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9803 1.98028C11.2732 1.68739 11.2732 1.21251 10.9803 0.919621C10.6874 0.626728 10.2126 0.626728 9.91967 0.919621L5.95 4.88929L1.98033 0.919621C1.68743 0.626728 1.21256 0.626728 0.919667 0.919621C0.626774 1.21251 0.626774 1.68739 0.919667 1.98028L4.88934 5.94995L0.919667 9.91962C0.626774 10.2125 0.626774 10.6874 0.919667 10.9803C1.21256 11.2732 1.68743 11.2732 1.98033 10.9803L5.95 7.01061L9.91967 10.9803C10.2126 11.2732 10.6874 11.2732 10.9803 10.9803C11.2732 10.6874 11.2732 10.2125 10.9803 9.91962L7.01066 5.94995L10.9803 1.98028Z",
    fill: "#525D71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "static/media/union.751fcf3f43837ae3eb571c15140d8dae.svg";
export { ForwardRef as ReactComponent };